import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';

import { ANALYTICS_OPERATIONAL_SUBJECT } from '../../constants/snippetAnalytics.ts';
import { setOnCreateError, type CreateErrorInfo } from '../../store/actions/createActions.ts';

import { useSnippetAnalytics } from './useSnippetAnalytics.ts';

/**
 * Fires `snippetApiCreate failed` (with `reason` + optional `statusCode`) on
 * create failures, gated behind `platform_editor_blocks_patch_4`. Mount before
 * any create can run (e.g. SnippetsProvider). Gate-off: nothing fires.
 */
export const useSnippetsCreateAnalytics = (): void => {
	const { fireFailedAnalytic } = useSnippetAnalytics();

	useEffect(() => {
		if (!fg('platform_editor_blocks_patch_4')) {
			return;
		}

		setOnCreateError((info: CreateErrorInfo) => {
			fireFailedAnalytic(ANALYTICS_OPERATIONAL_SUBJECT.SNIPPET_API_CREATE, {
				reason: info.reason,
				...(info.statusCode !== undefined && { statusCode: info.statusCode }),
			});
		});

		return () => {
			setOnCreateError(null);
		};
		// fireFailedAnalytic is memoised, so it's a stable dep.
	}, [fireFailedAnalytic]);
};
